import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-profile-headshot',
  templateUrl: './profile-headshot.component.html',
  styleUrls: ['./profile-headshot.component.scss'],
  standalone: false,
})
export class ProfileHeadshotComponent implements OnChanges {
  @Input() imageUrl: string | SafeUrl | null = null;

  pictureLoadError = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imageUrl']) {
      this.pictureLoadError = false;
    }
  }
}
